import { type FC, type ReactNode } from "react";

import { type V1ViewColumnDef as ViewColumnDef } from "@moment/api-collab/differential/v1-base-spec";
import { BookmarkIcon, NorthEastIcon, SouthEastIcon, SouthWestIcon } from "@moment/icons";

import { BasicTooltip, TooltipContent, TooltipTrigger } from "../Tooltip";

const ColumnItemEndAddon: FC<{
	displayOptions: ViewColumnDef | undefined;
}> = ({ displayOptions }) => {
	if (!displayOptions) {
		return null;
	}

	if (displayOptions.primaryDisplayColumn) {
		return (
			<BasicTooltip>
				<TooltipTrigger className="text-palette-gray-9 m-1">
					<BookmarkIcon />
				</TooltipTrigger>
				<TooltipContent>
					<div className="w-56">
						<div className="font-bold">Primary display column</div>
						<div>
							This column is shown at the top of the card in a strong font face.
						</div>
					</div>
				</TooltipContent>
			</BasicTooltip>
		);
	}

	let icon: ReactNode;
	let message = "";
	let details = "";
	switch (displayOptions.placementHint) {
		case "top-right":
			icon = <NorthEastIcon />;
			message = "Prefer top right corner";
			details = "When possible, place the column in the top right corner of the card.";
			break;
		case "bottom-right":
			icon = <SouthEastIcon />;
			message = "Prefer bottom right corner";
			details = "When possible, place the column in the bottom right corner of the card.";
			break;
		case "bottom-left":
			icon = <SouthWestIcon />;
			message = "Prefer bottom left corner";
			details = "When possible, place the column in the bottom left corner of the card.";
			break;
	}

	return (
		<BasicTooltip>
			<TooltipTrigger className="text-palette-gray-9 m-1">{icon as ReactNode}</TooltipTrigger>
			<TooltipContent>
				<div className="w-56">
					<div className="font-bold">{message}</div>
					<div>{details}</div>
				</div>
			</TooltipContent>
		</BasicTooltip>
	);
};

export default ColumnItemEndAddon;
